import { GerenciadorMensaisBase } from '@/domain/simulador/gerenciador-mensais-base'
import type { TCriarProximoGrupoMensais } from '@/domain/simulador/gerenciador-pos-conclusao.interface'
import type { TSimulacaoGrupoMensaisBase } from '@/domain/simulador/types/simulacao.type'

export class GerenciadorMensaisSacocVParcelado extends GerenciadorMensaisBase {
  override criarGrupoInicial(
    dataInicio: string,
    dataFim: string,
    valor: number,
    dataPrevisaoDeEntrega?: string,
  ): TSimulacaoGrupoMensaisBase {
    if (dataPrevisaoDeEntrega && new Date(dataPrevisaoDeEntrega) < new Date()) return []
    return super.criarGrupoInicial(dataInicio, dataFim, valor)
  }

  override criarProximoGrupo({ dataPrevisaoEntrega, dataUltimaMensal }: TCriarProximoGrupoMensais) {
    if (!dataPrevisaoEntrega) throw new Error('DataEntregaObrigatoriaParaProximoGrupo')

    if (dataPrevisaoEntrega && new Date(dataPrevisaoEntrega) < new Date()) {
      throw new Error('DataEntregaMenorQueDataAtual')
    }
    return super.criarProximoGrupo({ dataPrevisaoEntrega, dataUltimaMensal })
  }
}
